
import {defineComponent, PropType} from 'vue';
import PaginationLinkComponent from './PaginationLinkComp.vue';
import {PaginationType} from "@/types/IPaginationData";


export default defineComponent({
    name: "PaginationComponent",
    components: {
      PaginationLinkComponent
    },
    computed: {
      checkPrevPage() {
        return this.data.currentPage-3 > 1
      },
      checkNextPage() {
        return this.data.currentPage+3 < this.data.lastPage
      }
    },
    props: {
      data: {
        type: Object as PropType<PaginationType>,
        required: true
      }
    },
})
